<script setup lang="ts">
  import { useFormatting } from '@gat-ship/utils'
  import { type TenantUser } from '@gat-ship/types'
  import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent
  } from '@gat-ship/vue-components'
  import { useTenantUserUtils } from '../../composables/useTenantUserUtils'
  import { globalUtils } from '@gat-ship/utils'
  const { formatDateTime } = useFormatting()
  const { TenantUserUtils } = useTenantUserUtils()
  const props = defineProps<{
    tenantUser?: TenantUser
  }>()
</script>

<template>
  <TooltipProvider
    v-if="
      props.tenantUser &&
      !TenantUserUtils.isActiveTenantUser(props.tenantUser) &&
      !TenantUserUtils.isScheduledForActivation(props.tenantUser)
    "
  >
    <tooltip>
      <TooltipTrigger as-child>
        <div class="ml-auto flex flex-col items-center gap-0.5 text-center">
          <!-- <div class="text-sm font-medium">
            {{ globalUtils.date.timeSince(props.tenantUser?.activeTo ?? '') }}
          </div> -->
          <!-- <div class="text-muted-foreground text-xs">Deactivated</div> -->
          <div class="text-muted-foreground text-xs">
            {{ globalUtils.date.timeSince(props.tenantUser?.activeTo ?? '') }}
          </div>
        </div>
        <!-- <badge
          :class="
            cn(
              'flex w-fit items-center gap-1 p-1 px-2 text-xs group-hover:bg-neutral-200',
              props.class
            )
          "
          variant="secondary"
          @click.stop
        >
          <icon-deactivate
            class="size-3.5"
          />
          Deactivated
        </badge> -->
      </TooltipTrigger>
      <TooltipContent>
        Was deactivated on
        {{ formatDateTime(props.tenantUser?.activeTo) }}
      </TooltipContent>
    </tooltip>
  </TooltipProvider>
</template>
